import React from 'react'
import { FormDashboardLabel as Label } from './label'
import { InputPrefix } from './input-prefix'

const LinkAdder = ({
  prefix,
  className,
  label,
  defaultValue,
  defaultState = false,
  onChange = () => {},
  onRemove = () => {},
  ...props
}) => {
  const [isAdding, setIsAdding] = React.useState(defaultState)

  const handleChange = (e) => {
    const { name, value } = e.target
    if(typeof onChange === 'function'){
      onChange({
        target: {
          name,
          value: (prefix ? prefix : '')+value
        }
      })
    }
  }

  const handleRemove = () => {
    setIsAdding(false)

    if(typeof onRemove === 'function'){
      onRemove()
    }
  }

  return (
    <div className={className}>
      {
        isAdding &&
        <React.Fragment>
          <Label>{label}</Label>
          <InputPrefix
            prefix={prefix}
            removable
            onRemove={handleRemove}
            defaultValue={defaultValue}
            onChange={handleChange}
            {...props}
          />
        </React.Fragment>
      }
      {
        !isAdding &&
        <div className="flex items-center justify-between lg:justify-start">
          <p className="text-sm font-bold lg:w-1/4">{label}</p>
          <p className="link" onClick={() => setIsAdding(true)}>Add</p>
        </div>
      }
    </div>
  )
}

export { LinkAdder }